export default [
  {
    title: 'controls',
    icon: 'icon-controls',
    submenu: 'controls',
  },
  {
    title: 'solutions',
    icon: 'icon-solutions',
    submenu: 'solutions'
  },
  {
    title: 'key_features',
    icon: 'icon-features',
    submenu: 'keyFeatures'
  },
  {
    title: 'modifications',
    icon: 'icon-modifications',
    submenu: 'modifications'
  }
]